import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Error boundary global (F7 · #619). Los errores HTTP ya los maneja el
 * errorInterceptor (toast, sin perder contexto de la acción). Este handler
 * captura los fallos de runtime **no manejados** (excepciones JS, promesas
 * rechazadas) — el caso "pantalla en blanco" — y lleva a la página /error de
 * marca en vez de dejar la app rota. Buenas prácticas: no secuestra los 500
 * de acción (siguen como toast) ni los flujos de auth/error/mantención.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private router = inject(Router);

  handleError(error: unknown): void {
    // Siempre loguear para no perder el stack en dev/telemetría.
    console.error('[GlobalErrorHandler]', error);

    // Los errores HTTP los maneja el errorInterceptor (toast). No redirigir.
    const err = error as { rejection?: unknown };
    if (error instanceof HttpErrorResponse || err?.rejection instanceof HttpErrorResponse) {
      return;
    }

    // Evitar loops y no interrumpir auth ni las propias páginas sistémicas.
    const url = this.router.url.split('?')[0];
    if (url === '/error' || url === '/mantenimiento' || url.startsWith('/auth')) {
      return;
    }

    this.router.navigate(['/error']);
  }
}
